import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import CrackyHome from './pages/CrackyHome';
import CrackyClassic from './CrackyClassic';
import CrackySurvival from './CrackySurvival';

export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = sessionStorage.getItem('redirect');
    if (redirect) {
      sessionStorage.removeItem('redirect');
      navigate(redirect, { replace: true });
    }
  }, [navigate]);

  return (
    <main>
      <Routes>
        <Route exact path="/" element={<CrackyHome />} />
        <Route exact path="/classic" element={<CrackyClassic />} />
        <Route exact path="/survival" element={<CrackySurvival />} />
      </Routes>
    </main>
  );
}